import type posthog from "posthog-js";
import { isPostHogClientConfigured } from "@/lib/analytics/posthog-env";
import { shouldRecordPostHogSession } from "@/lib/analytics/posthog-session-replay-paths";

type PostHogClient = typeof posthog;

/**
 * Start or stop PostHog session recording based on the current pathname.
 * Safe no-op when PostHog is unconfigured or methods are unavailable.
 */
export function syncPostHogSessionRecording(
  client: PostHogClient,
  pathname: string | null | undefined,
): void {
  if (!isPostHogClientConfigured()) return;

  const wantRecording = shouldRecordPostHogSession(pathname);
  const started =
    typeof client.sessionRecordingStarted === "function"
      ? client.sessionRecordingStarted()
      : false;

  if (wantRecording && !started) {
    // Override sampling so allowlisted routes always record when project opt-in is on.
    client.startSessionRecording({ sampling: true });
    return;
  }

  if (!wantRecording && started) {
    client.stopSessionRecording();
  }
}
